import {useEffect} from "react";

export const useHeadlessUIDialogBypass = () => {
  const handleNotificationClose = (event:MouseEvent) => {
    const isNotificationSvg = (eventTarget:EventTarget|HTMLElement|null) => eventTarget instanceof SVGElement
      && eventTarget.getAttribute("name") === "toast-notification-close";

    const isNotificationSvgPath = (eventTarget:EventTarget|HTMLElement|null) => eventTarget instanceof SVGPathElement
      && isNotificationSvg(eventTarget.parentElement);

    if(isNotificationSvg(event.target) || isNotificationSvgPath(event.target))
      event.stopPropagation();
  };

  // <Dialog> component prevents click events outside the headlessui Portal.
  // Remove click restrictions from document root and allow click events to close <Notification> components
  useEffect(()=> {
    document.getElementById("root")?.removeAttribute("inert");
    window.addEventListener("click",handleNotificationClose);
    // Cleanup window event listener
    return () => window.removeEventListener("click",handleNotificationClose);
  });
};
